import { render } from "./Form51Receipt.vue?vue&type=template&id=6038d706&scoped=true"
import script from "./Form51Receipt.vue?vue&type=script&lang=js"
export * from "./Form51Receipt.vue?vue&type=script&lang=js"

import "./Form51Receipt.vue?vue&type=style&index=0&id=6038d706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6038d706"]])

export default __exports__